import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PersonComponent } from './components/person/person/person.component';
import { AuthGuard } from './components/guard/auth.guard';
import { AdminGuard } from './components/guard/admin.guard';
import { LoginComponent } from './components/login/login.component';
import { SessionHelper } from './helpers/sessionHelper';
import { ConfirmComponent } from './components/confirm/confirm.component';
import { PeopleComponent } from './components/pages/people/people.component';
import { PlanningComponent } from './components/pages/planning/planning.component';
import { OrgaccountComponent } from './components/pages/orgaccount/orgaccount.component';
import { UseraccountComponent } from './components/pages/useraccount/useraccount.component';
import { TimereportComponent } from './components/pages/timereport/timereport.component';
import { PortalComponent } from './components/pages/portal/portal/portal.component';
import { ForgotComponent } from './components/forgot/forgot.component';
import { CustomersComponent } from './components/pages/customers/customers/customers.component';
import { AdhocComponent } from './components/pages/adhoc/adhoc.component';
import { ProjectportalComponent } from './components/pages/portal/projectportal/projectportal.component';
import { CustomerportalControlComponent } from './components/customerportal/customerportal-control/customerportal-control.component';
import { CustomerpageComponent } from './components/pages/customers/customerpage/customerpage.component';
import { AdminComponent } from './components/pages/admin/admin.component';
import { DashboardComponent } from './components/pages/dashboard/dashboard.component';
import { SupportComponent } from './components/pages/support/support.component';
import { ReleasenotesComponent } from './components/pages/support/releasenotes/releasenotes.component';
import { CustomerportalLightComponent } from './components/pages/customerportal-light/customerportal-light.component';
import { CalendarComponent } from './components/pages/calendar/calendar.component';
import { FormsTestComponent } from './components/forms/forms-test.component';
import { NotificationAutomationComponent } from './components/pages/notification-automation/notification-automation.component';

const routes: Routes = [
  { path: 'login/:customer', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/:username', component: LoginComponent },
  { path: 'forgot/:username', component: ForgotComponent },
  { path: 'forgotten', component: ForgotComponent },
  { path: 'confirm', component: ConfirmComponent },
  { path: 'release', component: ReleasenotesComponent },
  { path: 'support', component: SupportComponent },
  { path: 'support', component: SupportComponent },
  {
    path: 'customerlight', component: CustomerportalLightComponent,
    canActivate: [AuthGuard]
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  {
    path: 'people', component: PeopleComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'planning', component: PlanningComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'orgaccount', component: OrgaccountComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'portal', component: PortalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'useraccount', component: UseraccountComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'time', component: TimereportComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customers', component: CustomersComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'adhoc', component: AdhocComponent,
    canActivate: [AuthGuard]
  },
  //{ path: 'projects/project', component: ProjectcontrolComponent,
  // canActivate: [AuthGuard] },
  {
    path: 'portal/project/:projectid', component: ProjectportalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customerportal/project/:projectid', component: ProjectportalComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customerportal', component: CustomerportalControlComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'customer/:customerId', component: CustomerpageComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'admin', component: AdminComponent,
    canActivate: [AuthGuard, AdminGuard]
  },
  {
    path: 'calendar', component: CalendarComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'orgaccount/forms', component: FormsTestComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'notification-automation', component: NotificationAutomationComponent,
    canActivate: [AuthGuard]
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
